import { render, staticRenderFns } from "./WeekResults.vue?vue&type=template&id=7bc792ce&scoped=true&"
import script from "./WeekResults.vue?vue&type=script&lang=js&"
export * from "./WeekResults.vue?vue&type=script&lang=js&"
import style0 from "./WeekResults.vue?vue&type=style&index=0&id=7bc792ce&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bc792ce",
  null
  
)

export default component.exports